export default __webpack_public_path__ + "static/media/Youtube.f4886422.svg";